import home from '../../assets/home.svg'
import piggy from '../../assets/piggy.svg'
import machine from '../../assets/machine.svg'
import mortgage from '../../assets/mortgage.svg'
import appliance from '../../assets/appliance.svg'
import personal from '../../assets/personal.svg'

export const services = [
    {
        image: home,
        title: 'Cash Point/Fixed deposits',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus quis lorem consequat fringilla elementum, facilisis laoreet volutpat. Eleifend erat libero in ac velit aliquam. Et, facilisis cras malesuada dignissim diam lacus. Scelerisque posuere dui morbi scelerisque.' 
    },
    {
        image: piggy,
        title: 'Piggy Bank',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus quis lorem consequat fringilla elementum, facilisis laoreet volutpat. Eleifend erat libero in ac velit aliquam. Et, facilisis cras malesuada dignissim diam lacus. Scelerisque posuere dui morbi scelerisque.' 
    },
    {
        image: machine,
        title: 'Machinery Loan',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus quis lorem consequat fringilla elementum, facilisis laoreet volutpat. Eleifend erat libero in ac velit aliquam. Et, facilisis cras malesuada dignissim diam lacus. Scelerisque posuere dui morbi scelerisque.' 
    },
    {
        image: mortgage,
        title: 'Mortgage Loan',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus quis lorem consequat fringilla elementum, facilisis laoreet volutpat. Eleifend erat libero in ac velit aliquam. Et, facilisis cras malesuada dignissim diam lacus. Scelerisque posuere dui morbi scelerisque.' 
    },
    {
        image: appliance,
        title: 'Home Appliance Loan',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus quis lorem consequat fringilla elementum, facilisis laoreet volutpat. Eleifend erat libero in ac velit aliquam. Et, facilisis cras malesuada dignissim diam lacus. Scelerisque posuere dui morbi scelerisque.' 
    },
    {
        image: personal,
        title: 'Personal Loan',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus quis lorem consequat fringilla elementum, facilisis laoreet volutpat. Eleifend erat libero in ac velit aliquam. Et, facilisis cras malesuada dignissim diam lacus. Scelerisque posuere dui morbi scelerisque.' 
    },
]